import request from '../../utils/request';
import { stringify } from 'qs';
// import { getSiteIp } from '../../utils/index';
//按督导员统计
export async function supervisor(params) {
  return request(`/api/blade-interact/supervisiontj/ddteachertj?${stringify(params)}`);
}
//按学科统计
export async function subject(params) {
  return request(`/api/blade-interact/supervisiontj/subjecttj?${stringify(params)}`);
}
//按年级统计
export async function grade(params) {
  return request(`/api/blade-interact/supervisiontj/gradetj?${stringify(params)}`);
}
//按教室统计
export async function teacher(params) {
  return request(`/api/blade-interact/supervisiontj/teachertj?${stringify(params)}`);
}
/** 学年查询 */
export async function getSchoolYearPage(params) {
  return request(`/api/blade-system/school-year/list?${stringify(params)}`);
}
/** 学期查询 */
export async function getSchoolTermPage(params) {
  return request(`/api/blade-system/school-term/page?${stringify(params)}`);
}

export async function getUserTeachingInfoPage(params) {
  return request(`/api/tscloud-statistics/system/getUserTeachingInfoPage?${stringify(params)}`);
}
